module.exports = __webpack_public_path__ + "img/no_announcement.1097b4b2.svg";